/**
 * Touch dropdown toggle for menus
 *
 * Adds the ability for touch devices to reveal a menu item's dropdown menu since
 * hover style is not guaranteed to work across all browsers in touch devices.
 *
 * This is achieved by adding a css class, during a touch event, that will have
 * the same styling as the :hover state.
 */
const TouchDropdownToggle = {
  _selectors: {
    triggerItem: '.js-touch-dropdown-toggle'
  },

  onDropdownShow: () => {},

  onDropdownHide: () => {},

  _activeMenuItem: null,

  init(events) {
    const self = this;

    // Sets custom callback fn
    if ( typeof events.onDropdownShow !== 'undefined' ) {
      this.onDropdownShow = events.onDropdownShow;
    }

    // Sets custom callback fn
    if ( typeof events.onDropdownHide !== 'undefined' ) {
      this.onDropdownHide = events.onDropdownHide;
    }

    // Event :: clicking on item triggers a dropdown menu
    document.querySelectorAll(this._selectors.triggerItem).forEach(node => {
      node.addEventListener('touchstart', self.toggleDropdown.bind(self));
    });
  },

  /**
   * Toggles an item's dropdown menu visibility via a css class
   */
  toggleDropdown(e) {
    const menuItem = e.currentTarget;

    if ( menuItem === this._activeMenuItem ) {
      this.hideDropdown(menuItem, e);

      return;
    }

    // Hides currently active dropdown
    if ( this._activeMenuItem !== null ) {
      this.hideDropdown(this._activeMenuItem, e);
    }

    if ( menuItem.classList.contains('dropdown-reveal') ) {
      this.hideDropdown(menuItem, e);
    } else {
      this.showDropdown(menuItem, e);
    }
  },

  showDropdown(menuItem, e) {
    menuItem.classList.add('dropdown-reveal');

    this._activeMenuItem = menuItem;

    // Custom callback fn
    this.onDropdownShow(e);
  },

  hideDropdown(menuItem, e) {
    menuItem.classList.remove('dropdown-reveal');

    this._activeMenuItem = null;

    // Custom callback fn
    this.onDropdownHide(e);
  }
};

export default TouchDropdownToggle;